import { useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { X, KeyRound } from "lucide-react";

// mode: "self" (needs current password) | "reset" (parent sets a child's password)
export function ChangePasswordModal({ mode = "self", studentId, studentName, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (next.length < 6) return toast.error("New password must be at least 6 characters.");
    if (next !== confirm) return toast.error("The new passwords don't match.");
    setBusy(true);
    try {
      if (mode === "self") await api.post("/auth/change-password", { current_password: current, new_password: next });
      else await api.post(`/students/${studentId}/password`, { new_password: next });
      toast.success(mode === "self" ? "Password updated!" : `${studentName}'s password updated!`);
      onClose();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] grid place-items-center p-6 bg-[#3D405B]/50 backdrop-blur-sm" onClick={onClose}>
      <div data-testid="change-password-modal" onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-3xl bg-white p-7 shadow-xl">
        <div className="flex items-center justify-between mb-1">
          <span className="flex items-center gap-2 font-head font-bold text-lg text-[#3D405B]"><KeyRound size={18} className="text-[#E07A5F]" /> {mode === "self" ? "Change password" : `Set ${studentName}'s password`}</span>
          <button data-testid="cp-close" onClick={onClose} className="text-[#6B7280] hover:text-[#3D405B]"><X size={18} /></button>
        </div>
        <p className="text-sm text-[#6B7280] mb-5">{mode === "self" ? "Choose a new password for your account." : `Give ${studentName} a new password they can sign in with.`}</p>

        {mode === "self" && (
          <input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password"
            className="w-full rounded-xl border border-[#EAE6DF] px-4 py-2.5 outline-none focus:ring-2 focus:ring-[#E07A5F] mb-3" />
        )}
        <input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (min 6 characters)"
          className="w-full rounded-xl border border-[#EAE6DF] px-4 py-2.5 outline-none focus:ring-2 focus:ring-[#E07A5F] mb-3" />
        <input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password"
          className="w-full rounded-xl border border-[#EAE6DF] px-4 py-2.5 outline-none focus:ring-2 focus:ring-[#E07A5F] mb-5" />
        <button data-testid="cp-submit" onClick={submit} disabled={busy}
          className="w-full rounded-full bg-[#E07A5F] text-white py-2.5 font-semibold hover:bg-[#c96851] transition-colors disabled:opacity-60">
          {busy ? "Saving…" : "Save password"}
        </button>
      </div>
    </div>
  );
}
